/** PURE_IMPORTS_START .._.._Observable,.._.._observable_concat PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { concat as concatStatic } from '../../observable/concat';
Observable.concat = concatStatic;
//# sourceMappingURL=concat.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/observable/concat.js
// module id = 617
// module chunks = 0